// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"74c8d824","56":"421e2483","694":"6858cd47"}[chunkId] + ".chunk.js";
};